import _extends from '@babel/runtime/helpers/extends';
import React__default, { createElement } from 'react';
import { P as Prefix } from './Prefix-BPrTX79_.js';
import { S as Suffix } from './Suffix-KgfxsKtd.js';
import { I as InputWrapper, a as InputGroup, b as InputContainer } from './Input.styles-9zD2U5dJ.js';
import { V as ValidationMessage } from './ValidationMessage-C3oKmvI2.js';
import { R as RenderLabelEndWithHelptip } from './RenderLabelEndWithHelptip-Bcx8tHFi.js';
import { I as InputLabel } from '../InputLabel/InputLabel-DAs7B_Vt.js';
import { a as TaktIdConsumer } from '../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';

const StyledInput = ({
  inputElement,
  inputRef,
  ...restProps
}) => {
  if (inputElement === 'input') {
    return /*#__PURE__*/React__default.createElement("input", _extends({}, restProps, {
      ref: inputRef
    }));
  }
  return /*#__PURE__*/createElement(inputElement, {
    ...restProps,
    ...{
      inputRef
    }
  }, restProps.children);
};
const InternalInput = ({
  id,
  className = '',
  disabled = false,
  label,
  ariaLabel,
  message = '',
  messageE2EId,
  statusType,
  type = 'text',
  prefix,
  suffix,
  fullWidth = false,
  inline = false,
  hideLabel = false,
  inputRef,
  help,
  inputElement = 'input',
  renderLabelStart,
  renderLabelEnd,
  value,
  ignoreTextDirection,
  taktId,
  taktValue,
  ...rest
}) => {
  const a11yProps = {
    ...(ariaLabel ? {
      'aria-label': ariaLabel
    } : {}),
    /**
    * Add a 'aria-describedby' when any message is applied to the input
    */
    ...(message ? {
      'aria-describedby': `${id}-input-message`
    } : {}),
    /**
    * Error get a `'aria-invalid="true"`
    */
    ...(statusType === 'error' ? {
      'aria-invalid': true
    } : {})
  };
  return /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
    taktId: taktId,
    taktValue: taktValue,
    fallbackId: createStormTaktId('input')
  }, ({
    getDataTaktAttributes
  }) => /*#__PURE__*/React__default.createElement(InputWrapper, {
    className: className,
    $inline: inline,
    $fullWidth: fullWidth
  }, label && /*#__PURE__*/React__default.createElement(InputLabel, _extends({
    hidden: hideLabel,
    renderLabelStart: renderLabelStart,
    renderLabelEnd:
    /**
     * Support the `help` prop by folding it into renderLabelEnd
     */
    help ? /*#__PURE__*/React__default.createElement(RenderLabelEndWithHelptip, {
      renderLabelEnd: renderLabelEnd,
      help: help
    }) : renderLabelEnd,
    htmlFor: id
  }, getDataTaktAttributes({
    taktIdSuffix: 'label'
  })), label), /*#__PURE__*/React__default.createElement(InputGroup, {
    $statusType: statusType,
    dir: ignoreTextDirection ? 'ltr' : undefined,
    $disabled: disabled
  }, prefix && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, prefix), /*#__PURE__*/React__default.createElement(InputContainer, null, /*#__PURE__*/React__default.createElement(StyledInput, _extends({
    inputElement: inputElement
  }, getDataTaktAttributes(), rest, a11yProps, {
    id: id,
    type: type,
    value: value,
    inputRef: inputRef,
    disabled: disabled
  }))), suffix && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, suffix)), !!message && /*#__PURE__*/React__default.createElement(ValidationMessage, {
    value: value,
    messageId: `${id}-input-message`,
    message: message,
    messageE2EId: messageE2EId,
    statusType: statusType
  })));
};
const Input = props => {
  const {
    disabled,
    ignoreTextDirection,
    prefix,
    suffix
  } = props;
  return /*#__PURE__*/React__default.createElement(InternalInput, _extends({}, props, prefix && {
    prefix: /*#__PURE__*/React__default.createElement(Prefix, {
      $ignoreTextDirection: ignoreTextDirection,
      $disabled: disabled
    }, prefix)
  }, suffix && {
    suffix: /*#__PURE__*/React__default.createElement(Suffix, {
      $ignoreTextDirection: ignoreTextDirection,
      $disabled: disabled
    }, suffix)
  }));
};

/** @deprecated This will be removed in StormUI 5.x. Use `Input` instead. */
const InputFormGroup = Input;

export { Input as I, InternalInput as a, InputFormGroup as b };
//# sourceMappingURL=Input-CdU0IzVd.js.map
